// extracted by mini-css-extract-plugin
export default {"menuList":"menuList__oGX15"};